export default "__VITE_ASSET__BjNHA$_v__"